import { useCallback, useEffect, useRef, useState } from 'react'

export const useContainerSize = () => {
  const [size, setSize] = useState({ width: 0, height: 0 })
  const containerRef = useRef<HTMLDivElement | null>(null)

  const { width, height } = size

  const handleResize = useCallback(() => {
    setSize({
      width: containerRef.current?.offsetWidth || 0,
      height: containerRef.current?.offsetHeight || 0,
    })
  }, [])

  useEffect(() => {
    if (containerRef.current) {
      window.addEventListener('resize', handleResize)
    }
    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return { width, height, containerRef }
}
